import type { FaireProductEntity } from "../../entity_types/product";

export const p_uc43hpw6p2: FaireProductEntity = {
  token: "p_uc43hpw6p2",
  type: "product",
  name: "Bridesmaid Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/1d35e36a7570ec522e57a99bfb51a82aec89023efd6d3c4e87139ea2fd19fa33.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b471eafc3180acb457046ba9043422ee2c892ccb3911644d0788a53819e26b80.jpeg",
    "https://cdn.faire.com/fastly/8f708d10b6669d7eefeef048d1a61544f52e4585042511dcf022636031703856.jpeg",
    "https://cdn.faire.com/fastly/3939c9867e98def82bdff61083c489236c52c57662dbda2375eed30b3a29605d.jpeg",
    "https://cdn.faire.com/fastly/ded6efdecfcb676aab3afbd04ccecf8ffdcc78113e459f5051d51ace7e19add1.jpeg",
    "https://cdn.faire.com/fastly/52ed4d28db78b1ad632cc762a8ae67db00440b165b5f0f5d33fd27baad8ae8a9.jpeg"
  ],
  priceDollars: 6.75,
  description: "For the friend who said “yes” to every wedding adventure, brought the bachelorette party energy, helped find the perfect stripper, and showed up for every unforgettable moment long before anyone walked down the aisle. These socks are well earned. ❤️\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:33:23.860Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
